import { SellerReviewList, SellerScore } from "@/components/molecules"
import { getSellerByHandle } from "@/lib/data/seller"
import { getTranslate } from "@/tolgee/server"
import { SellerProps } from "@/types/seller"

export const SellerReviewTab = async ({
  seller_handle,
}: {
  seller_handle: string
}) => {
  const t = await getTranslate()
  const { photo, name, reviews, summary } = await getSellerByHandle(seller_handle, true, true) as SellerProps
  const reviewCount = summary?.review_count || 0
  const rating = summary?.rating_avg || 0

  return (
    <div className="bg-white border border-black/10 rounded-md overflow-hidden mt-8">
      <div className="border-b border-black/10 px-6 pt-3 pb-[13px]">
        <h3 className="text-[14px] font-medium text-[#0a0a0a] tracking-[-0.15px]">{t("product_details.seller_reviews_heading")}</h3>
      </div>
      <div className="flex flex-col lg:flex-row items-stretch">
        <div className="shrink-0 border-b lg:border-b-0 lg:border-r border-black/10 lg:w-[220px] p-4">
          <SellerScore rate={rating} reviewCount={reviewCount} />
        </div>
        <div className="flex-1 min-w-0">
          <SellerReviewList reviews={reviews} />
        </div>
      </div>
    </div>
  )
}
 